module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "vertical",
    attrs: {
      "alt": "image",
      "src": "images/f0004-01.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "copyright"
    }
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "copy"
    }
  }), _vm._v("Text copyright © 2017 by Heidi Gibson."), _c('br'), _vm._v("Photographs copyright © 2017 by Antonis Achilleos.")]), _vm._v(" "), _c('p', [_vm._v("All rights reserved. No part of this book may be reproduced in any form without written permission from the publisher.")]), _vm._v(" "), _c('p', [_vm._v("ISBN 9781452158303 (epub)")]), _vm._v(" "), _c('p', [_vm._v("Library of Congress Cataloging-in-Publication Data"), _c('br'), _vm._v("Names: Gibson, Heidi, 1972- author. | Achilleos, Antonis, photographer."), _c('br'), _vm._v("Title: Muffins & biscuits : 50 recipes to start your day with a smile / Heidi"), _c('br'), _vm._v("Gibson ; photographs by Antonis Achilleos."), _c('br'), _vm._v("Other titles: Muffins and biscuits"), _c('br'), _vm._v("Description: San Francisco : Chronicle Books, [2017] | Includes index."), _c('br'), _vm._v("Identifiers: LCCN 2016021108 | ISBN 9781452158259 (hc : alk. paper)"), _c('br'), _vm._v("Subjects: LCSH: Muffins. | Biscuits. | LCGFT: Cookbooks."), _c('br'), _vm._v("Classification: LCC TX770.M83 G53 2017 | DDC 641.81/57—dc23 LC record available at "), _c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/2016021108",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2016021108")])]), _vm._v(" "), _c('p', [_vm._v("Designed by "), _c('span', {
    staticClass: "font1"
  }, [_vm._v("Vanessa Dina")]), _c('br'), _vm._v("Prop styling by "), _c('span', {
    staticClass: "font1"
  }, [_vm._v("Spork")]), _c('br'), _vm._v("Typesetting by "), _c('span', {
    staticClass: "font1"
  }, [_vm._v("Frank Brayton")])]), _vm._v(" "), _c('p', [_vm._v("Chronicle books and gifts are available at special quantity discounts to corporations, professional associations, literacy programs, and other organizations. For details and discount information, please contact our premiums department at "), _c('a', {
    attrs: {
      "href": "mailto:corporatesales@chroniclebooks.com"
    }
  }, [_vm._v("corporatesales@chroniclebooks.com")]), _vm._v(" or at 1-800-759-0190.")]), _vm._v(" "), _c('p', [_vm._v("Chronicle Books LLC"), _c('br'), _vm._v("680 Second Street"), _c('br'), _vm._v("San Francisco, California 94107"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.chroniclebooks.com/",
      "target": "_blank"
    }
  }, [_vm._v("www.chroniclebooks.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-725bdf56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04copyright.vue
// module id = 66
// module chunks = 0